export default "__VITE_ASSET__DXbeVBbX__"